/**
 * Toggle native fullscreen for the given element. If any element is currently
 * in fullscreen it is exited, otherwise the given element is requested.
 */
export function toggleFullscreen(element: Element | null | undefined) {
    if (!element) {
        return;
    }

    if (document.fullscreenElement) {
        document.exitFullscreen().catch(() => {
        });
    } else {
        (element as HTMLElement).requestFullscreen().catch(() => {
        });
    }
}
